export const productTypeOptions = [
  { value: "N/A", label: "Please Select" },
  { value: "Edibles,Mint", label: "Wonder Minis" },
  { value: "Edibles,Gummy", label: "Wonder Gummies" },
];

export default {
  productTypeOptions,
};
